import { createFileRoute } from '@tanstack/react-router'
import EditionCover from 'Edition/components/sections/Layout/EditionCover/EditionCover'

export const Route = createFileRoute('/work/$workId_/edition/$editionId/layout-cover')({
    component: EditionCover,
})
